import React from 'react';
import "../components/Projects.css";

function Projects() {
  return (
    <div className="services">
      <h2>Projects</h2>
      <div className='servicesContent'>
        <div className='cards'>
          <a href="https://ringles.web.app" target="_blank" rel="noopener noreferrer">
            <div className='card-3'>
              <h1>Ringles®</h1>
              <img src='/images/ringles.png' alt='Ringles' />
            </div>
          </a>

          <a href="https://www.allskog.no" target="_blank" rel="noopener noreferrer">
            <div className='card-3'>
              <h1>Allskog</h1>
              <img src='/images/allskog.png' alt='Macbook' />
            </div>
          </a>

          <a href="https://bypedroneres.github.io/Coinevoo/" target="_blank" rel="noopener noreferrer">
            <div className='card-3'>
              <h1>Coinevoo®</h1>
              <img src='/images/coinevoo.png' alt='Macbook' />
            </div>
          </a>

          <a href="https://bypedroneres.github.io/Interlix/" target="_blank" rel="noopener noreferrer">
            <div className='card-3'>
              <h1>Interlix</h1>
              <img src='/images/interlix.png' alt='Macbook' />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Projects;
